import { type Control, useWatch } from "react-hook-form";
import type {
	ServicesFormInput,
	ServicesFormOutput,
} from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormSchema";
import {
	getServicesPriceFieldVisibility,
	type ServicesPriceFieldVisibility,
} from "web_myplann/Portfolio/Helpers/servicesPriceFieldVisibility";

export const useServicesPriceFields = (
	control: Control<ServicesFormInput, unknown, ServicesFormOutput>,
): ServicesPriceFieldVisibility => {
	const {
		commodityService,
		unitOfMeasurement,
		pricePerUnit,
		depositAmount,
		fixedPriceByFrequency,
	} = useWatch({ control });

	return getServicesPriceFieldVisibility({
		commodityService,
		unitOfMeasurement,
		pricePerUnit,
		depositAmount,
		fixedPriceByFrequency,
	});
};
